import React from "react";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { exportData } from "../lib/exporter";
import { useAuth } from "../context/AuthContext";

export function ExportButton({ filename, title, subtitle, columns, rows, color, testid = "export", size = "sm", label = "Esporta" }) {
  const { companyLogo } = useAuth();
  const run = (format) => {
    if (!rows || rows.length === 0) { toast.error("Nessun dato da esportare"); return; }
    try { exportData({ format, filename, title, subtitle, columns, rows, color, logo: companyLogo }); toast.success(`Esportazione ${format === "excel" ? "Excel" : "PDF"} avviata`); }
    catch (e) { toast.error("Errore durante l'esportazione"); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size={size} data-testid={`${testid}-btn`}><Download size={16} className="mr-1" /> {label}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => run("excel")} data-testid={`${testid}-excel`}><FileSpreadsheet size={15} className="mr-2 text-emerald-600" /> Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("pdf")} data-testid={`${testid}-pdf`}><FileText size={15} className="mr-2 text-red-600" /> PDF</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
